import Textarea from "@/components/common/Textarea.vue";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from "moment/moment.js";

export default {
    name: 'ShowObjectComment',

    components: {
        Textarea
    },

    data () {
        return {
            comment: null,
            list: [],
            loading: false,
            objectId: null
        }
    },

    setup: () => ({ v$: useVuelidate() }),
    validations () {
        return {
            comment: { required }
        }
    },

    methods: {
        async show (objectId) {
            this.list = [];
            this.resetState();
            this.objectId = objectId;
            this.loading = true;
            try {
                const response = await this.getObjectComment();
                if (!response || response.error || response.canceled) return;
                const { data } = response;
                this.list = this.BasicHelper.cloneObject(data.list);
                this.$refs['modal-window'].show();
            } finally {
                this.loading = false;
            }
        },

        resetState() {
            this.v$.$reset();
            this.comment = null;
        },

        async getObjectComment() {
            return this.ApiRequest.requestAsync(
                `object/comment/show/${this.objectId}`,
                this.ApiRequest.REQUEST_GET,
                {},
                `object-comment-show-${this.objectId}`,
                true
            );
        },

        async submit () {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) return;
            this.loading = true;
            try {
                const response = await this.ApiRequest.requestAsync(
                    `object/comment/store`,
                    this.ApiRequest.REQUEST_POST,
                    {comment: this.comment, objectId: this.objectId },
                    'object-comment-store',
                    true
                );
                if (!response || response.error || response.canceled) return;
                const { data } = response;
                this.list = this.BasicHelper.cloneObject(data.list);
                this.resetState();
            } finally {
                this.loading = false;
            }
        },

        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },

        close () {
            this.$refs['modal-window'].hide();
        }
    }
}